import React, { useState } from 'react';
import './ProductShareButtons.scss';
import { getLocation } from "../../../utils/getLocation";
import { T } from '../../../utils/I18n/I18n';

const WebShareApi = () => {
    const url = getLocation();
    const [modal, setModal] = useState(false);

    const closeModal = () => setModal(false);
    const openModal = () => setModal(true);

    const copyLink = () => {
        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(url);
            // TODO: Add feedback for successful copy (e.g., toast notification)
        }
        // TODO: Add backup method of copying text (e.g., execCommand for older browsers)
    };

    const handleSharing = async () => {
        if (navigator.share) {
            try {
                await navigator.share({ url });
                console.log("Hooray! Your content was shared to the world");
            } catch (error) {
                console.log(`Oops! I couldn't share to the world because: ${error}`);
            }
        } else {
            openModal();
        }
    };

    return (
        <>
            {modal && (
                <div onClick={closeModal} className="share-background-modal">
                    <div className="share-dialog is-open">
                        <header className="share-header">
                            <h3 className="dialog-title"><T id="product.shareTitle" /></h3>
                            <button onClick={closeModal} className="close-button">
                                <svg className="share-svg">
                                    <use href="#close" />
                                </svg>
                            </button>
                        </header>
                        <div className="targets">
                            <a
                                target="_blank"
                                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
                                className="share-button"
                                rel="noopener noreferrer" // Dodano dla bezpieczeństwa
                            >
                                <svg className="share-svg">
                                    <use href="#facebook" />
                                </svg>
                                <span>Facebook</span>
                            </a>

                            <a
                                target="_blank"
                                href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(url)}`}
                                className="share-button"
                                rel="noopener noreferrer" // Dodano dla bezpieczeństwa
                            >
                                <svg className="share-svg">
                                    <use href="#twitter" />
                                </svg>
                                <span>Twitter</span>
                            </a>
                        </div>
                        <div className="link">
                            <div className="pen-url">{url}</div>
                            <button className="copy-link" onClick={copyLink}>
                                <T id="product.copyLink" />
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <button
                onClick={handleSharing}
                className="share-button share-button-main"
                type="button"
                title="Share this article"
            >
                <svg className="share-svg">
                    <use href="#share-icon" />
                </svg>
                <span><T id="product.share" /></span>
            </button>

            <svg className="hidden">
                <defs>
                    <symbol id="share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round" className="feather feather-share">
                        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                        <polyline points="16 6 12 2 8 6" />
                        <line x1="12" y1="2" x2="12" y2="15" />
                    </symbol>

                    <symbol id="facebook" viewBox="0 0 24 24" fill="#3b5998" stroke="#3b5998" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round" className="feather feather-facebook">
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                    </symbol>

                    <symbol id="twitter" viewBox="0 0 24 24" fill="#1da1f2" stroke="#1da1f2" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round" className="feather feather-twitter">
                        <path
                            d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
                    </symbol>

                    <symbol id="close" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-square">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                        <line x1="9" y1="9" x2="15" y2="15" />
                        <line x1="15" y1="9" x2="9" y2="15" />
                    </symbol>
                </defs>
            </svg>
        </>
    );
};

export default React.memo(WebShareApi);